// src/components/layouts/FooterLegal.jsx
import React from "react";

export function FooterLegal({ children }) {
  return (
    <footer className="footer-legal w-100">
      <div className="footer-inner">
        {children}
      </div>
    </footer>
  );
}

export function ContactLink({ href, children }) {
  return (
    <div className="footer-contact">
      <a href={href}>{children}</a>
    </div>
  );
}

export function SmallPrint({ children }) {
  return (
    <div className="footer-smallprint">
      {children}
    </div>
  );
}
